export const HOLDING_TOKEN_FORM = "configHoldingTokenForm";
export const ADD_HOLDING_FUNNEL_FORM = "configAddHoldingFunnelForm";
export const DELETE_HOLDING_FUNNEL_FORM = "configDeleteHoldingFunnelForm";
export const EDIT_HOLDING_FUNNEL_FORM = "configEditHoldingFunnelForm";
export const ADD_SUBSCRIPTION_HOLDING_FORM = "configAddSubscriptionHoldingForm";
export const DELETE_SUBSCRIPTION_HOLDING_FORM = "configDeleteSubscriptionHoldingForm";